import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import config from 'config';
import { DragDropContext } from 'react-beautiful-dnd';

import styleGrid from '../../blocks/grid/style.pcss';
import Buttons from '../../blocks/buttons';
import { closeSelect, changeDate } from '../../blocks/select/actions';
import Tasks from '../../blocks/tasks';
import MaterialDatePicker from '../../blocks/date-picker';
import Header from '../../blocks/header';
import Select from '../../blocks/select';
import Button from '../../blocks/button';
import Sports from '../../blocks/sports';
import Tournaments from '../../blocks/tournaments';

import { sportsReorder, getSportsSuccess, sportsSelect, sportsVisible, setCountTotalSports } from '../../blocks/sports/actions';
import { tournamentsReorder, getTournamentsSuccess, searchEvent, getTournamentsStart, resetTournaments } from '../../blocks/tournaments/actions';
import { check, resetCheck, updateCountEvents } from '../../blocks/checked/actions';

import { SELECT_SPECIAL } from './types';

import style from './style.pcss';

const cx = classNames.bind(style);

@connect((state) => ({
    select       : state.select,
    tournaments  : state.tournaments,
    selectedSport: state.sports.selected
}), (dispatch) => ({
    dispatchGetSportsSuccess   : (params) => dispatch(getSportsSuccess(params)),
    dispatchResetTournaments   : () => dispatch(resetTournaments()),
    dispatchSportsSelect       : (params) => dispatch(sportsSelect(params)),
    dispatchSportsReorder      : (params) => dispatch(sportsReorder(params)),
    dispatchSportsVisible      : (params) => dispatch(sportsVisible(params)),
    dispatchTournamentsReorder : (params) => dispatch(tournamentsReorder(params)),
    dispatchGetTournaments     : (params) => dispatch(getTournamentsSuccess(params)),
    dispatchSearchEvent        : (params) => dispatch(searchEvent(params)),
    dispatchGetTournamentsStart: () => dispatch(getTournamentsStart()),
    dispatchCheck              : (params) => dispatch(check(params)),
    dispatchCloseSelect        : () => dispatch(closeSelect()),
    dispatchResetCheck         : () => dispatch(resetCheck()),
    dispatchSetCountTotalSports: (params) => dispatch(setCountTotalSports(params)),
    dispatchUpdateCountEvents  : (params) => dispatch(updateCountEvents(params)),
    dispatchChangeDate         : (params) => dispatch(changeDate(params))
}))
class Home extends Component {

    static displayName = '[page] home';

    static contextTypes = {
        transport: PropTypes.object
    };

    static propTypes = {
        select                     : PropTypes.object,
        tournaments                : PropTypes.object,
        selectedSport              : PropTypes.number,
        dispatchGetSportsSuccess   : PropTypes.func,
        dispatchResetTournaments   : PropTypes.func,
        dispatchSportsSelect       : PropTypes.func,
        dispatchSportsReorder      : PropTypes.func,
        dispatchSportsVisible      : PropTypes.func,
        dispatchTournamentsReorder : PropTypes.func,
        dispatchGetTournaments     : PropTypes.func,
        dispatchSearchEvent        : PropTypes.func,
        dispatchGetTournamentsStart: PropTypes.func,
        dispatchCheck              : PropTypes.func,
        dispatchCloseSelect        : PropTypes.func,
        dispatchResetCheck         : PropTypes.func,
        dispatchSetCountTotalSports: PropTypes.func,
        dispatchUpdateCountEvents  : PropTypes.func,
        dispatchChangeDate         : PropTypes.func
    };

    state = {
        positionId : '',
        searchError: null,
        startDate  : Date.now(),
        endDate    : null
    };

    componentDidMount() {
        this.request();
    }

    componentDidUpdate(prevProps) {
        const { special, period } = this.props.select;

        if(special.value !== prevProps.select.special.value) {
            switch(special.value) {
                case SELECT_SPECIAL.POPULAR :
                    this.request(true);
                    break;
                case SELECT_SPECIAL.ALL_SPORTS:
                    this.request();
                    break;
            }
        }

        if(period.value !== prevProps.select.period.value) {
            const { startDate } = this.state;
            const currentPeriod = config.selectPeriod.find((item) => item.text === period.value);

            if(currentPeriod.count) {
                const selectDate = 86400000 * currentPeriod.count + startDate;

                return this.changeEndDate(selectDate);
            }

            switch(period.value) {
                case 'все время' :
                    this.changeEndDate();
                    break;
            }
        }
    }

    request = async (popular = false, gameId = null) => {
        const { endDate, startDate } = this.state;
        const {
            dispatchGetSportsSuccess,
            dispatchGetTournaments,
            dispatchSetCountTotalSports,
            dispatchGetTournamentsStart,
            dispatchResetTournaments,
            dispatchUpdateCountEvents
        } = this.props;
        let countSports = 0;
        let tournaments = {};

        try {
            const events = await this.context.transport
                .publish('booker./events/v3', {
                    method: 'groupingByTournament',
                    params: {
                        ...endDate && {
                            startDate,
                            endDate
                        },
                        ...popular && { popular },
                        ...gameId && { sportIds: gameId },
                        ns: 'prematch'
                    }
                });

            const sports = events.map((sport) => {
                countSports += sport.total; // Количество всех событий

                if(sport.tournaments.length) {
                    tournaments[sport._id] = sport.tournaments; // чемпионаты по видам спорта
                } else {
                    dispatchGetTournaments([])
                }

                return {
                    gameId: sport._id,
                    title : sport.title,
                    qty   : sport.total,
                    _id   : sport._id
                }
            });

            dispatchResetTournaments();
            dispatchGetTournamentsStart();
            dispatchGetSportsSuccess(sports);
            dispatchGetTournaments(tournaments);
            dispatchSetCountTotalSports(countSports);
            dispatchUpdateCountEvents({
                sports,
                tournaments
            })
        } catch(e) {
            console.error(e)
        }
    };

    get elIdInput() {
        const {
            select: { special },
            dispatchSportsVisible
        } = this.props;
        const { searchError, positionId } = this.state;

        if(special.value === SELECT_SPECIAL.SEARCH_ID) {
            let error = '';

            if(searchError) {
                error = <span className={cx('sort-msg', 'sort-msg_inline')}>{searchError}</span>;
            }

            dispatchSportsVisible(false);

            return (
                <div className={cx('search')}>
                    <div className={style['select-caption']}>ID события</div>
                    <input
                        className={cx('search__input')}
                        placeholder="Введите ID события"
                        type="text"
                        onChange={this.handleChangeId}
                        ref={(node) => { this.input = node }}
                        value={positionId}
                        onKeyPress={this.handleKeyPress}
                    />
                    <Button onClick={this.handleSearch} className={cx('search__button')}>&#128269;</Button>
                    {error}
                </div>
            )
        } else {
            dispatchSportsVisible(true);

            return null;
        }
    }

    handleKeyPress = (e) => {
        if(e.key === 'Enter') {
            this.handleSearch();
        }
    };

    changeEndDate = (date = null, type = 'endDate') => {
        const { special: { value } } = this.props.select;
        const { endDate } = this.state;

        this.props.dispatchResetCheck();
        this.props.dispatchChangeDate(date);

        if(type !== 'endDate' && endDate && date > endDate) {
            this.setState({ endDate: null });
        }
        this.setState({ [type]: date }, () => {
            this.request(value === SELECT_SPECIAL.POPULAR);
        });
    };

    get elPeriodInput() {
        const { period, special: { value } } = this.props.select;
        const { endDate, startDate } = this.state;

        if(period.value !== 'задать период' || value === SELECT_SPECIAL.SEARCH_ID) {
            return null;
        }

        const optionsStyle = {
            maxWidth   : 100,
            height     : 30,
            marginTop  : 15,
            paddingLeft: 5,
            border     : '1px solid rgb(190, 190, 190)'
        };

        return (
            <Fragment>
                <div className={cx('date-picker-container')}>
                    <span className={cx('dash')}>от </span>

                    <MaterialDatePicker
                        id={'startDate'}
                        onChange={this.changeEndDate}
                        value={new Date(startDate)}
                        minDate={new Date()}
                        optionsStyle={optionsStyle}
                    />
                </div>
                <div className={cx('date-picker-container')}>
                    <span className={cx('dash')}>до <sub> (включительно)</sub> </span>
                    <MaterialDatePicker
                        id={'endDate'}
                        onChange={this.changeEndDate}
                        value={endDate ? new Date(endDate) : endDate}
                        minDate={new Date(startDate + 86400000)}
                        optionsStyle={optionsStyle}
                    />
                </div>
            </Fragment>
        )
    }

    get elMessage() {
        const { special } = this.props.select;

        if(special.value === SELECT_SPECIAL.SEARCH_ID) {
            return 'Нажмите иконку “поиска”, чтобы  событие появилось в списке.'
        } else {
            return 'Вы можете поменять порядок следования элементов в списке. Для этого перетащите нужный пункт в нужное вам место.'
        }
    }

    handleChangeId = (e) => {
        this.setState({ positionId: e.target.value })
    };

    handleSearch = async () => {
        const { positionId } = this.state;
        const { tournaments: { items }, dispatchSearchEvent, dispatchCheck } = this.props;

        if(!positionId.trim() || !isFinite(positionId) || items.length && items.find((tournament) => tournament.positionId === Number(positionId))) {
            return false;
        }
        const resultSearch = await this.context.transport
            .publish('booker./events/v1', {
                method: 'eventsList',
                params: {
                    eventPosition: positionId
                }
            });

        if(resultSearch && resultSearch.length > 0) {
            this.setState({ searchError: null });

            const event = {
                title          : resultSearch[0].event.eventTitle,
                positionId     : resultSearch[0].event.position,
                ns             : resultSearch[0].ns,
                gameId         : resultSearch[0].gameId,
                _id            : resultSearch[0].id,
                total          : 1,
                tournamentTitle: `${resultSearch[0].tournamentTitle}.`,
                category       : resultSearch[0].categoryTitle
            };

            dispatchSearchEvent(event);
            dispatchCheck({
                kind      : 'tournaments',
                sport     : { gameId: resultSearch[0].gameId },
                tournament: event
            });
        } else {
            this.setState({ searchError: 'Ничего не найдено' });
        }

        this.setState({ positionId: '' });
    };

    onDragEnd = (result) => {
        // dropped outside the list
        if(!result.destination) {
            return;
        }

        switch(result.type) {
            case 'SPORTS':
                this.props.dispatchSportsReorder({
                    startIndex: result.source.index,
                    endIndex  : result.destination.index
                });
                break;
            case 'TOURNAMENTS':
                this.props.dispatchTournamentsReorder({
                    startIndex: result.source.index,
                    endIndex  : result.destination.index,
                    gameId    : this.props.selectedSport
                });
                break;
        }
    };

    closeSelect = () => {
        const { select, dispatchCloseSelect } = this.props;

        for(const key in select) {
            if(select[key].show) {
                dispatchCloseSelect();
                break;
            }
        }
    };

    onClickHandler = (gameId) => () => {
        this.props.dispatchSportsSelect(gameId);
    };

    defaultSort = () => {
        this.request(this.props.select.special.value === SELECT_SPECIAL.POPULAR);
    };

    render() {
        return (
            <Fragment>
                {this.props.tournaments.isLoaded || this.props.select.special.value === SELECT_SPECIAL.SEARCH_ID ? (
                    <div onClick={this.closeSelect}>
                        <Header />
                        <div className={styleGrid['grid']}>
                            <div className={styleGrid['grid__column-left']}>
                                <div className={styleGrid['grid__selects']}>
                                    <div>
                                        <div className={style['select-caption']}>Логотип сети</div>
                                        <Select id="logo" values={config.selectLogo} />
                                    </div>
                                    <div>
                                        <div className={style['select-caption']}>Тип линии</div>
                                        <Select id="line" values={config.selectLine} />
                                    </div>
                                    <div>
                                        <div className={style['select-caption']}>Период выборки</div>
                                        <Select id="period" values={config.selectPeriod} disabled={this.props.select.special.value === SELECT_SPECIAL.SEARCH_ID} />
                                    </div>
                                    <div>
                                        <div className={style['select-caption']}>Специальное</div>
                                        <Select id="special" values={config.selectSpecial} />
                                    </div>
                                    {this.elIdInput}
                                </div>
                                <div className={style['select-period']}>
                                    {this.elPeriodInput}
                                </div>
                                <div className={styleGrid['grid__sort']}>
                                    <span className={style['sort-msg']}>{this.elMessage}</span>
                                    {this.props.select.special.value !== SELECT_SPECIAL.SEARCH_ID && <Button className={style['sort-btn']} onClick={this.defaultSort}>Сортировка по умолчанию</Button>}
                                </div>
                                <div className={styleGrid['grid__main']}>
                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                        <Sports onClickHandler={this.onClickHandler} />
                                        <Tournaments />
                                    </DragDropContext>
                                </div>
                                <Buttons />
                            </div>
                            <div className={styleGrid['grid__column-right']}>
                                <Tasks />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={cx('overlay')} />
                )}
            </Fragment>

        )
    }

}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home/index.js